/**
 * --------------------------------------------------------------------------
 * Basic Modules: ContentSlider.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG         = false;
const NAME          = 'contentSlider';
const DATA_KEY      = 'contentSlider';
const EVENT_KEY     = `.${DATA_KEY}`;
const LOG_KEY       = `[${NAME}]`;

const Default = {
    centerMode: true,
    mobileFirst: true,
};

const Event   = {
    RESIZE          :  `resize${EVENT_KEY}`,
};

const ClassName = {
};

const Selector = {
    TOGGLE          : '[data-toggle-content-slider]',
};

const DataAttr = {};

/**
 * @type {constructor}
 */
class ContentSlider {

    /**
     * Constructor.
     *
     * @param element
     * @param config
     */
    constructor(element, config)
    {
        DEBUG && console.log(LOG_KEY, 'init');

        this.resizeTimeout = null;

        this._element   = element;
        this._config    = this._getConfig(config);
        this._slickConfig = this._getSlickConfig();

        //this._addEventListeners();
        this._setup();
    }


    destroy() {
        this.$el.off('.' + name);
        this.$el.find('*').off('.' + name);

        this.$el.removeData(name);
        this.$el = null;
    }

    // Private

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _getSlickConfig() {

        let slickConfig = Util.getSlickConfig(this._config);

        let breakPoints = Util.breakPoints;
        let responsive = {};

        const options = Object.entries(this._config);
        const entries = Object.entries(breakPoints);
        for (const [key, value] of entries) {

            // Step through the configuration options, and check if
            // the name begins with the breakpoint key (xs, sm, md, etc)
            for (const [optionKey, optionValue] of options) {

                if (optionKey.startsWith(key, 0)) {

                    // Remove the breakpoint prefix from the option key and add it to the
                    // responsive object
                    let newOptionKey = optionKey.substring(2);
                    newOptionKey = newOptionKey.charAt(0).toLowerCase() + newOptionKey.slice(1);

                    if (! responsive[key]) {
                        responsive[key] = {};
                        responsive[key]['breakpoint'] = value;
                        responsive[key]['settings'] = {};
                    }

                    responsive[key]['settings'][newOptionKey] = optionValue;
                }
            }
        }

        let responsiveArray = [];

        for (const [key, value] of Object.entries(responsive)) {
            responsiveArray.push(value);
        }
        slickConfig['responsive'] = responsiveArray.reverse();

        DEBUG && console.log(LOG_KEY, 'Slick Config', slickConfig);

        return slickConfig;
    }

    _isMobile() {
        return (Util.viewport === 'mobile' || Util.viewport === 'phablet');
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    _setup() {

        let $slider = $(this._element);
        $slider.slick(this._slickConfig);
    }

    /**
     * Handle the resizing of the window
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        this._setup();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ContentSlider._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ContentSlider(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ContentSlider._jQueryInterface;
$.fn[NAME].Constructor = ContentSlider;


export default ContentSlider;
